import { render, staticRenderFns } from "./ProveedorShowData.vue?vue&type=template&id=9862f386&"
import script from "./ProveedorShowData.vue?vue&type=script&lang=js&"
export * from "./ProveedorShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports